import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';

@Component({
  selector: 'app-view-all-items',
  templateUrl: './view-all-items.component.html',
  styleUrls: ['./view-all-items.component.scss']
})
export class ViewAllItemsComponent {

  @Input() block: any;
  @Input() lang: string = '';
  public results: any = [];
  public queryParams: string = '';
  public counterPage: number = 0;
  public viewMore = false;

  constructor(
    public nodeService: NodeService, 
    private location: Location,
    private helpersService: HelpersService
  ) { }

  search(obj: any = null, page: number = 0): void {
    this.counterPage = 0;
    this.queryParams = obj.queryParams;
    if (obj.event === 'click' && this.helpersService.isBrowser) {
      this.location.replaceState(`${window.location.pathname}${obj.queryParamsRoute? '?'+ obj.queryParamsRoute : '' }`);
    }
    this.nodeService.getView(this.lang, this.block.tipo_view, this.block.oggetto_view, this.queryParams, page, this.block.preview).subscribe(res => {
      this.results = res.rows;
      this.isMoreContent(res.pager);
      this.nodeService.searchItemsBS.next(this.results);
    });
  };

  public addContentResult(): void {
    this.nodeService.getView(this.lang, this.block.tipo_view, this.block.oggetto_view, this.queryParams, this.counterPage, this.block.preview).subscribe(res => {
      this.results = [
        ...this.results,
        ...res.rows
      ];
      this.isMoreContent(res.pager);
      this.nodeService.searchItemsBS.next(this.results);
    });
  }

  private isMoreContent(pager: any): void {
    if (pager) {
      if (((pager.current_page + 1) * pager.items_per_page) < Number(pager.total_items)) {
        this.viewMore = true;
      } else {
        this.viewMore = false;
      }
      if ((this.counterPage <= pager.total_pages - 1)) {
        this.counterPage += 1;
      }
    }
  }


}
